import contentstack from "@contentstack/delivery-sdk";

import { GlobalSettings, HomePageContent, PageContent } from "../../models/app-data-model";

// NOTE: exclude this from testing as it's just an 3rd party lib. test our code only.

export type ContentTypes =
  | "spectrumhealth_org_homepage"
  | "pages"
  | "spectrumhealth_org_primary_header"
  | "spectrumHealthOrgGlobalNav"
  | "pages_migration_poc"
  | "spectrumhealth_org_global_settings"
  | "global_alerts_spectrumhealth_org"
  | "global_search_no_results_spectrumhealth_org"
  | "sh_global_toolbar";

const ContentStackApiService = {
  getContent(
    contentType: ContentTypes,
    entryUid?: string,
    referencedFields?: string[],
    branch?: string
  ): Promise<HomePageContent | PageContent[] | GlobalSettings> {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

    // don't load the api client if we don't have what we need.
    if (!process.env.GATSBY_API_KEY || !process.env.GATSBY_DELIVERY_TOKEN || !process.env.GATSBY_ACTIVE_ENV) {
      return new Promise(() => undefined);
    }

    const stack = contentstack.stack({
      apiKey: process.env.GATSBY_API_KEY,
      deliveryToken: process.env.GATSBY_DELIVERY_TOKEN,
      environment: process.env.GATSBY_ACTIVE_ENV,
      ...(branch && { branch })
    });

    if (entryUid) {
      const query = stack.contentType(contentType).entry(entryUid);

      if (referencedFields) {
        query.includeReference(referencedFields);
      }

      return query.fetch<HomePageContent>();
    } else {
      const entries = stack.contentType(contentType).entry();

      if (referencedFields) {
        entries.includeReference(referencedFields);
      }

      return entries.find<PageContent>().then(function success(result) {
        return result.entries as PageContent[];
      });
    }
  }
};

export default ContentStackApiService;
